import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { TestimonialsGrid, TestimonialsHeading, TestimonialsWrap } from './MidnightMigrationScreen.style';
import { MidnightMigrationTestimonialCard, MidnightMigrationTestimonialType } from './MidnightMigrationTestimonialCard';

const testimonialItems: Array<MidnightMigrationTestimonialType> = [
    {
        title: 'Clean app, great UI and services',
        body: 'Really easy to move around, everything feels fast, and support was quick when I needed a hand.',
        author: 'M.B.',
    },
    {
        title: 'Smooth switch from my old site',
        body: 'I was worried about migrating but the process was straightforward and I was playing again the same day.',
        author: 'timcychvgam',
    },
    {
        title: 'Sports & casino in one place',
        body: 'Love having both products without juggling apps. Promotions are clear and the layout is simple.',
        author: 'S.K.',
    },
    {
        title: 'Reliable payouts',
        body: 'Withdrawals landed when expected. The account section makes it obvious what is bonus vs cash.',
        author: 'bmcyvhvgzam',
    },
];

export const MidnightMigrationTestimonialsSection = observer(
    'MidnightMigrationTestimonialsSection',
    (): JSX.Element => {
        return (
            <TestimonialsWrap>
                <TestimonialsHeading>
                    <I18n
                        langKey='account.midnight-migration.testimonials-heading'
                        defaultText='Join over 800k players'
                    />
                </TestimonialsHeading>
                <TestimonialsGrid>
                    {testimonialItems.map((item) => (
                        <MidnightMigrationTestimonialCard
                            item={item}
                            key={item.author}
                        />
                    ))}
                </TestimonialsGrid>
            </TestimonialsWrap>
        );
    }
);
